import Card from '@Utils/Card';
import React, { Fragment, useEffect, useMemo, useState } from 'react';
import surveyPopup from '@Theme/images/survey-popup.svg';
import surveyMobile from '@Theme/images/survey-mobile.svg';
import surveyModal from '@Theme/images/survey-modal.svg';
import './questionLayoutTemplates.scss';
import './surveyBaseStyles.scss';
import { Form, Modal, Select } from 'antd';
import { FormOutlined } from '@ant-design/icons';

const templates = [
  {
    name: 'ON_SITE_CLASSIC',
    title: 'On-Site Classic',
    description:
      "Want to run short surveys on your website? This layout is the perfect way to seek user feedback and insights proactively when the user is ON your site - in real-time. The survey can be time delayed to pop from page's bottom right or left. You can choose from, or build your own, theme. Use-cases: Use this one to run customer satisfaction surveys post purchase, generate leads, collect customer insights, profile your anonymous visitors, collect insights from users who are about to leave your website etc.",
    img: surveyPopup,
    disabled: false,
  },
  {
    name: 'ON_SITE_MODAL',
    title: 'On-Site Modal',
    description:
      'Need page blocking lead generation forms for newsletter sign-ups? Or, you want an exit survey for users leaving your site from critical areas in the product workflow (say, the cart page)? Or, you need to capture more leads from your SEM traffic? The modal window is designed to capture users attention and make him/her respond to your questionnaire. Use-cases: Reduce cart abandonment, increase lead generation / email subscription. Any page blocking survey to collect customer insights.',
    img: surveyModal,
    disabled: true,
  },
  {
    name: 'MOBILE_MODAL',
    title: 'Mobile Modal',
    description:
      'Need to capture responses from your ever growing mobile website users and want to be drive lead genertion from them? So that you get real time insights. Use-cases: Reduce cart abandonment, lead generation, customer satisfaction surveys for your mobile website.',
    img: surveyMobile,
    disabled: true,
  },
];

const languages = [
  {
    value: 'PERSIAN',
    label: 'فارسی',
  },
  {
    value: 'ENGLISH',
    label: 'English',
  },
];

function SurveyTemplateCard(props) {
  return (
    <div
      className="template-card"
      onClick={props.onClick}
      style={{
        borderColor: props.selected ? 'transparent' : undefined,
        outline: props.selected ? '3px solid #3E89EE' : undefined,
        cursor: props.disabled ? 'not-allowed' : 'pointer',
        opacity: props.disabled ? 0.4 : 1,
      }}
    >
      <span className="template-card-title">{props.title}</span>
      <div className="img-placeholder">
        <img src={props.img} alt="" loading="eager" height="193px" />
      </div>
      <p className="template-card-desc">{props.description}</p>
    </div>
  );
}

function QuestionLayoutModalContent(props) {
  return (
    <div style={{ display: 'flex', flex: 1, gap: 16, alignItems: 'center' }}>
      {templates.map(({ name, title, img, disabled, description }) => (
        <SurveyTemplateCard
          key={name}
          onClick={() => {
            if (disabled) return;

            if (props?.value !== name) {
              props?.onChange(name);
            }
            props.onLayoutChange(name);
            props.onSelect();
          }}
          selected={props?.value === name}
          title={title}
          description={description}
          disabled={disabled}
          img={img}
        />
      ))}
    </div>
  );
}

function QuestionLayoutTemplates(props) {
  const [selectedMode, setSelectedMode] = useState(false);

  useEffect(() => {
    if (!props?.value?.layout) {
      setSelectedMode(true);
    }
  }, [props?.value?.layout]);

  const title = useMemo(() => {
    const template = templates.find(
      (template) => template.name === props?.value?.layout
    );

    return template?.title;
  }, [props?.value]);

  return (
    <Form
      style={{ maxWidth: 'unset' }}
      onFieldsChange={([field]) => {
        const [name] = field.name ?? [];

        props.onChange({
          ...(props?.value ?? {}),
          [name]: field.value,
        });
      }}
      initialValues={{ ...(props?.value ?? {}) }}
    >
      <Card>
        <div className="question-header">
          <span className="section-title">Layout Setting</span>
        </div>
        <div
          className="question-content question-with-content"
          style={{
            alignItems: 'flex-start',
            flexDirection: 'column',
            gap: 36,
          }}
        >
          <div className="layout-setting-title">
            <span className="layout-setting-label">Survey Layout</span>
            <div
              onClick={() => setSelectedMode(true)}
              className="layout-selector"
            >
              <span>{title || '--'}</span>
              <FormOutlined />
            </div>
          </div>
          <div className="layout-setting-title">
            <span className="layout-setting-label">Survey Language</span>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <Form.Item
                name="language"
                requiredMark="optional"
                rules={[{ required: true, message: 'language is required' }]}
                noStyle
              >
                <Select
                  style={{ minWidth: 200 }}
                  options={languages}
                  placeholder="Choose a Language"
                />
              </Form.Item>
            </div>
          </div>
        </div>
      </Card>
      <Modal
        title="Select a Layout"
        footer={null}
        open={selectedMode}
        closeIcon={<Fragment />}
        width={'fit-content'}
        onCancel={() => {
          if (props?.value?.layout) {
            setSelectedMode(false);
          }
        }}
      >
        <Form.Item name="layout" noStyle>
          <QuestionLayoutModalContent
            onLayoutChange={props.onLayoutChange}
            onSelect={() => setSelectedMode(false)}
          />
        </Form.Item>
      </Modal>
    </Form>
  );
}

export { QuestionLayoutTemplates };
